<template>
    <MapPin :map="map" :coords="cluster.coords">
        <div class="posfinder-screen__pin posfinder-screen__pin--number" @click="zoomToGroup">
            <div class="posfinder-screen__pin-number">
                {{ cluster.count }}
            </div>
        </div>
    </MapPin>
</template>

<script>
import MapPin from "./MapPin";

export default {
    name: "ClusterPin",
    components: {
        MapPin
    },
    data() {
        return {
            offset: 0,
            zoom: this.map.zoom
        }
    },
    props: {
        map: {
            type: Object,
            required: true
        },
        cluster: {
            type: Object,
            required: true
        },
    },
    methods: {
        zoomToGroup() {
            this.offset += 1 - (this.zoom - this.map.zoom) < 0 ?
                this.offset = 1 :
                this.offset += 1 - (this.zoom - this.map.zoom);

            this.map.autoCenter(this.cluster.locations.map(l => l.coords), this.offset);
            this.zoom += 1;
        },
    }
}
</script>
